import CurrentUserAvatar from "components/shared/CurrentUserAvatar";
import NotificationIndicator from "features/Nav/components/Nav/parts/NotificationIndicator";
import Button from "hardcover-ui/components/Button";
import LoadingSpinner from "hardcover-ui/components/LoadingSpinner";
import classNames from "lib/classNames";

type Props = {
  onClick?: () => void;
  active?: boolean;
  loading?: boolean;
};

export default function ToggleSidebarButton({
  onClick = () => {},
  active = false,
  loading = false,
}: Props) {
  return (
    <div className="flex justify-center mr-1">
      <Button
        onMouseUp={onClick}
        className={classNames(
          "relative bg-background rounded-full text-sm text-foreground",
          active
            ? "outline-hidden ring-2 ring-offset ring-offset-gray-800 ring-white"
            : "focus:outline-hidden focus:ring-2 focus:ring-offset focus:ring-offset-gray-800 focus:ring-white",
        )}
      >
        <span className="sr-only">Open user menu</span>
        {loading ? (
          <div className="absolute bottom-0 right-0 w-4 h-4 bg-background rounded-full">
            <LoadingSpinner size="sm" />
          </div>
        ) : (
          false
        )}
        <NotificationIndicator />
        <CurrentUserAvatar size="md" isLink />
      </Button>
    </div>
  );
}
